module.exports = __webpack_public_path__ + "img/bank-13-kj.8c5cadf9.svg";